import React from 'react';
import SellerSidebar from './SellerSidebar';

const SellerLayout = ({ children }) => {
    return (
        <div className="flex min-h-screen bg-gray-50">
            {/* Sidebar */}
            <SellerSidebar />

            {/* Main Content Area */}
            <div className="flex-1 ml-64 transition-all duration-300">
                {/* Top Header (Optional, if needed for global search or notifications not in sidebar) */}
                {/* <div className="bg-white h-16 shadow-sm border-b border-gray-200 sticky top-0 z-40">
           Header Content 
        </div> */}

                {/* Page Content */}
                <div className="p-8">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default SellerLayout;
